import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, LoadingController, AlertController } from '@ionic/angular/lazy';
import { OrderService } from 'src/app/services/order.service';
import { ObserverService } from 'src/app/services/observer.service';

@Component({
    selector: 'app-order-item-edit',
    templateUrl: './order-item-edit.page.html',
    styleUrls: ['./order-item-edit.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderItemEditPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    params = {};
    @Input() order_id = null;
    @Input() item_id = null;
    @Input() item_title = null;
    item = null;
    modal_css_class = '';

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private loadingController: LoadingController,
        private orderService: OrderService,
        private observerService: ObserverService
    ) { }

    ngOnInit() {

        if(this.order_id) {


            if(this.item_id) {


                this.loadData().then(() => {

                    if (this.item.customer_note) {
                        this.params['customer_note'] = this.item.customer_note;
                    }
                    else {
                        this.params['customer_note'] = "";
                    }

                    if (this.item.internal_note) {
                        this.params['internal_note'] = this.item.internal_note;
                    }
                    else {
                        this.params['internal_note'] = "";
                    }

                })
                .catch(() => { });

            }
        }

        this.observerService.subscribe('network_status_changed|order_item_edit_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => { }).catch(() => { });
                }
                else {
                    this.presentAlert("Offline", "You must be online to edit an order item, please check your network connection and try again.");
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("network_status_changed|order_item_edit_modal");
    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading item").then(() => {
                this.orderService.getOrderItem(this.order_id, this.item_id).then((item) => {
                    if(item) {
                        this.item = item;
                    }
                    this.loading_spinner.dismiss();
                    resolve();
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    close() {
        this.modalController.dismiss();
    }

    update() {
        this.presentSpinner("Updating order item").then(() => {
            this.orderService.updateOrderItem(this.order_id, this.item_id, this.params).then(async () =>{
                await this.spinner.dismiss();
                await this.modalController.dismiss();
            })
            .catch(() => {
                this.spinner.dismiss();
            });
        });
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

}
